import React from "react";

const Contact = () => {

  const phoneNumber = "919340214828"; // your phone number
  const whatsappNumber = "919340214828"; // WhatsApp number

  return (

    <section className="container py-5">

      <h2 className="text-center fw-bold mb-4">
        Contact Us
      </h2>

      <div className="row justify-content-center">

        <div className="col-md-6 text-center">

          <p className="text-muted">
            For consultation please contact us
          </p>

          {/* Call Button */}

          <a
            href={`tel:+${phoneNumber}`}
            className="btn btn-success m-2"
          >
            📞 Call Now
          </a>

          {/* WhatsApp Button */}

          <a
            href={`https://wa.me/${whatsappNumber}`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary m-2"
          >
            💬 WhatsApp
          </a>

        </div>

      </div>

    </section>

  );
};

export default Contact;